import { __decorate, __metadata } from "tslib";
import { GiftCardAmountTypeEnum, GiftCardProviderEnum, IsNotEmptyObjectWithLVS, IsUndefinable, IsUUIDWithLVS } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsEnum, IsInstance, IsNotEmpty, IsNumber, IsString, MaxLength, ValidateNested } from 'class-validator';
import { CartExposeGroup } from '../../cart/interface';
import { OrderExposeGroup } from '../interface';
import { ReadOrderGiftCardDeliveryDto } from './ReadOrderGiftCardDeliveryDto';
import { ReadOrderGiftCardDiscountDto } from './ReadOrderGiftCardDiscountDto';
import { ReadOrderGiftCardSenderDto } from './ReadOrderGiftCardSenderDto';
export class ReadOrderGiftCardElemDto {
}
__decorate([
    ApiProperty({ type: () => String, description: 'Promotion uuid', example: 'b22c590f-c4c4-4761-b528-8287e0ec3777' }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsUUIDWithLVS('4'),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], ReadOrderGiftCardElemDto.prototype, "uuid", void 0);
__decorate([
    ApiProperty({ enum: GiftCardAmountTypeEnum, example: GiftCardAmountTypeEnum.FREE }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsEnum(GiftCardAmountTypeEnum, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], ReadOrderGiftCardElemDto.prototype, "amountType", void 0);
__decorate([
    ApiProperty({ type: () => Number, description: 'Gif card load ' }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], ReadOrderGiftCardElemDto.prototype, "load", void 0);
__decorate([
    ApiProperty({ type: () => Number, description: 'Gif card price' }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], ReadOrderGiftCardElemDto.prototype, "price", void 0);
__decorate([
    ApiProperty({ type: () => ReadOrderGiftCardDiscountDto }),
    Type(() => ReadOrderGiftCardDiscountDto),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(ReadOrderGiftCardDiscountDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", ReadOrderGiftCardDiscountDto)
], ReadOrderGiftCardElemDto.prototype, "discount", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'Promotion uuid', example: 'b22c590f-c4c4-4761-b528-8287e0ec3777' }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], ReadOrderGiftCardElemDto.prototype, "image", void 0);
__decorate([
    ApiProperty({ type: () => Number, description: 'Gif card quantity' }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], ReadOrderGiftCardElemDto.prototype, "quantity", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadOrderGiftCardDeliveryDto }),
    Type(() => ReadOrderGiftCardDeliveryDto),
    IsUndefinable({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(ReadOrderGiftCardDeliveryDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", ReadOrderGiftCardDeliveryDto)
], ReadOrderGiftCardElemDto.prototype, "delivery", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadOrderGiftCardSenderDto }),
    Type(() => ReadOrderGiftCardSenderDto),
    IsUndefinable({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(ReadOrderGiftCardSenderDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", ReadOrderGiftCardSenderDto)
], ReadOrderGiftCardElemDto.prototype, "sender", void 0);
__decorate([
    ApiPropertyOptional({ enum: GiftCardProviderEnum, example: GiftCardProviderEnum.GOPARROT }),
    IsUndefinable({ always: true }),
    IsEnum(GiftCardProviderEnum, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], ReadOrderGiftCardElemDto.prototype, "provider", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Promotion uuid', example: 'b22c590f-c4c4-4761-b528-8287e0ec3777' }),
    IsUndefinable({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], ReadOrderGiftCardElemDto.prototype, "gan", void 0);
//# sourceMappingURL=ReadOrderGiftCardElemDto.js.map